/**
 * `{concrete example}` placeholders Gabber writes where a real detail from the
 * creator would beat an invented one. Mirrors the backend matcher: single
 * braces, no JSON-ish `{"`, no `{{template}}`, no padding inside the braces.
 */
const PLACEHOLDER_PATTERN = /(?<!\{)\{(?![{"\s])([^{}\n]{1,200}?)(?<!\s)\}(?!\})/g;

export interface PlaceholderSegment {
  text: string;
  placeholder: boolean;
}

export function placeholderSegments(text: string | null | undefined): PlaceholderSegment[] {
  const source = text ?? '';
  const segments: PlaceholderSegment[] = [];
  let cursor = 0;
  for (const match of source.matchAll(PLACEHOLDER_PATTERN)) {
    const start = match.index ?? 0;
    if (start > cursor) segments.push({ text: source.slice(cursor, start), placeholder: false });
    segments.push({ text: match[0], placeholder: true });
    cursor = start + match[0].length;
  }
  if (cursor < source.length) segments.push({ text: source.slice(cursor), placeholder: false });
  return segments;
}

export function countPlaceholders(...texts: Array<string | null | undefined>): number {
  return texts.reduce(
    (total, text) =>
      total + placeholderSegments(text).filter(segment => segment.placeholder).length,
    0
  );
}
